import { render, staticRenderFns } from "./CreateMassRentalObjectsTable.vue?vue&type=template&id=2c6ca042&scoped=true"
import script from "./CreateMassRentalObjectsTable.vue?vue&type=script&lang=ts"
export * from "./CreateMassRentalObjectsTable.vue?vue&type=script&lang=ts"
import style0 from "./CreateMassRentalObjectsTable.vue?vue&type=style&index=0&id=2c6ca042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6ca042",
  null
  
)

export default component.exports